import { Box } from '@mantine/core';
import React from 'react';
import { useGoalComments } from '../../goal/services/useGoalQueries';
import { CommentForm } from './CommentForm';
import { CommentList } from './CommentList';
import { useTodoComments } from '@/features/todo/services/useTodoQueries';

interface CommentSectionProps {
    goalId?: string;
    todoId?: string;
}

export const CommentSection: React.FC<CommentSectionProps> = ({
    goalId,
    todoId,
}) => {
    const { data: goalComments = [], isLoading: isGoalCommentsLoading } =
        useGoalComments(goalId);
    const { data: todoComments = [], isLoading: isTodoCommentsLoading } =
        useTodoComments(todoId);

    // 현재 컨텍스트에 따라 적절한 댓글 데이터와 로딩 상태 선택
    const comments = goalId ? goalComments : todoComments;
    const isLoading = goalId ? isGoalCommentsLoading : isTodoCommentsLoading;

    // goalId나 todoId 중 하나는 반드시 있어야 함
    if (!goalId && !todoId) return null;

    return (
        <Box>
            <CommentList
                comments={comments}
                isLoading={isLoading}
                targetId={goalId || todoId}
                targetType={goalId ? 'goal' : 'todo'}
            />
            <CommentForm
                targetId={goalId || todoId}
                targetType={goalId ? 'goal' : 'todo'}
            />
        </Box>
    );
};
